// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"4bfca432","316":"3d313851","453":"23146af4","624":"e22d7e1c","927":"37d9838a"}[chunkId] + ".chunk.js";
};